// Takes a blob of html and replaces any productline/brand/category link with the right YMM(BBE) from session.
// This is fully reactive!  If your fitment changes (even without a route change) or if the content changes everything is re-rendered correctly
import { linkBuilders } from './mixins'

export default {
    mixins: [linkBuilders],
    methods: {
        getRefittedUrl(url) {
            // router.resolve cant resolve full urls so we are removing 'https://site-domain' if a full url is passed through
            let sourceUrl = url.replace(`https://${this.$sitewideData.domain}`, '')
            if (sourceUrl.startsWith('http')) return url // Return external urls
            sourceUrl = this.formatUrl(sourceUrl) // Format the url before trying to resolve

            const routeInfo = this.$router.resolve(sourceUrl)

            if (
                !this.$store.state.fitment.data.year || // no ymm to update, just return the same url
                !routeInfo.resolved || // even possible?
                !routeInfo.resolved.matched || // even possible?
                routeInfo.resolved.matched[0].path === '*'
            )
                // it's a catch-all path, not ymmable
                return sourceUrl

            const route = routeInfo.resolved
            const obj = {
                name: route.name,
                params: Object.assign({}, route.params),
                query: Object.assign({}, route.query),
            }

            return this.$router.resolve(this.linkBuilder(obj)).href
        },
        formatUrl(url) {
            // Add trailing slash if it doesn't exist
            if (url.includes('?')) {
                if (!url.includes('/?')) url = url.replace('?', '/?')
            } else if (url.slice(-1) !== '/') url += '/'

            // Internal links in Storyblok do not start with a '/' so we need to reformat them so they do
            if (url[0] !== '/') url = `/${url}`

            return url
        },
    },
}
